import gql from 'graphql-tag';

export const residentIdForUser = gql(`
    query residentIdForUser ($userId: UUID!, $propertyId: UUID!) {
      resident: residentByUserId(userId: $userId, propertyId: $propertyId) {
        id
      }
    }
`);
